import "@babel/polyfill";
import "./polyfills/custom-event";
import "whatwg-fetch";

import Vue from "vue";
import ChartIqAdvanced from "./components/ChartIqAdvanced";
import ChartIqBasic from "./components/ChartIqBasic";
import ChartControlTimespan from "./components/ChartControlTimespan";
import ChartControlBenchmark from "./components/ChartControlBenchmark";
import ChartControlBenchmarkQuickselect from "./components/ChartControlBenchmarkQuickselect";
import ChartControlNotation from "./components/ChartControlNotation";
import { mdg2Client } from "./util/instances.js";

Vue.config.productionTip = false;

export default class {
  vueInstance;
  elementId;

  constructor(elementId = "#fdsg-container") {
    this.elementId = elementId;
    this.vueInstance = undefined;
  }

  async init() {
    this.vueInstance = new Vue({
      el: this.elementId,
      components: {
        ChartIqAdvanced,
        ChartIqBasic,
        ChartControlTimespan,
        ChartControlBenchmark,
        ChartControlBenchmarkQuickselect,
        ChartControlNotation
      }
    });

    try {
      await mdg2Client.setConnectionFromFetchConfiguration("/token");
      await mdg2Client.connect();
      console.log("Connected");
    } catch (mdg2clientError) {
      console.error("Connection Failed.", mdg2clientError);
    }
  }

  destroy() {
    this.vueInstance.$destroy();
    return this;
  }
}
